export default class ReferenceControleDetailController {
    static $inject = [
        '$stateParams',
        '$state',
        'ReferencesControleService',
        'notification',
        'ReferencesControleCommunicationService',
        'MassiaApplicationService'
    ];

    constructor($stateParams, $state, ReferencesControleService, notification, ReferencesControleCommunicationService, MassiaApplicationService) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.ReferencesControleService = ReferencesControleService;
        this.notification = notification;
        this.ReferencesControleCommunicationService = ReferencesControleCommunicationService;
        this.MassiaApplicationService = MassiaApplicationService;
    }

    $onInit() {
        this.loading = false;
        this.reference = {};

        this.ongletOpen = {
            isEnteteOpen: true
        };

        this.initReference();
    }

    getRouteCourante() {
        const domaine = this.$state.current.name;
        return domaine.substring(0, domaine.indexOf('.'));
    }

    async initReference() {
        this.reference = { id: this.$stateParams.id };
        if (this.reference.id) {
            this.startLoading();
            try {
                this.reference = await this.ReferencesControleService.getReferenceById(this.reference.id);
            } catch (ex) {
                if (ex.status === 404) {
                    this.goListReference();
                }
                this.notification.error(ex.data);
            } finally {
                this.stopLoading();
            }
        } else {
            this.goListReference();
        }
    }

    async getReference(referenceId) {
        this.reference = await this.ReferencesControleService.getReferenceById(referenceId);
    }

    goListReference() {
        this.$state.go(this.getRouteCourante() + '.list', {}, { reload: true });
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
